import { ClientFactory, LAUNCH } from 'smarterfhir';

export async function createFHIRClient() {
  try {
    const clientFactory = new ClientFactory();
    const client = await clientFactory.createEMRClient(LAUNCH.EMR);
    if (!client) throw new Error('no client found');
    return client;
  } catch (reason) {
    console.error('Failed due to', reason);
    if (!(reason instanceof Error)) throw new Error(`Unknown Error: ${reason}`);
    if (
      reason.message.includes(
        "No 'state' parameter found. Please (re)launch the app."
      ) ||
      reason.message.includes('Could not find any JWT token')
    ) {
      return console.error('No EMR connection established.');
    }
    if (reason.message.includes('User is not available'))
      return console.error('Waiting for Web Launch...');
  }
}

export const isFHIRContext = () => {
  // Checks if the current session has an auth token with an EMR sever
  const SMART_KEY = 'SMART_KEY';
  return sessionStorage.getItem(SMART_KEY) !== null;
};
